module.exports = __webpack_public_path__ + "img/rest@2x.9993f48d.png";